import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { translations, LOGO_URL, CONTACT } from "@/i18n";
import Header from "@/sections/Header";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import Services from "@/sections/Services";
import WhyUs from "@/sections/WhyUs";
import QuoteForm from "@/sections/QuoteForm";
import Testimonials from "@/sections/Testimonials";
import Coverage from "@/sections/Coverage";
import FAQ from "@/sections/FAQ";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";
import AdminPage from "@/pages/AdminPage";

function HomePage() {
  const [lang, setLang] = useState("no");
  const t = translations[lang];

  return (
    <>
      <Header t={t} lang={lang} setLang={setLang} logo={LOGO_URL} contact={CONTACT} />
      <main>
        <Hero t={t} contact={CONTACT} />
        <Marquee />
        <Services t={t} />
        <WhyUs t={t} />
        <QuoteForm t={t} lang={lang} />
        <Testimonials lang={lang} t={t} />
        <Coverage t={t} />
        <FAQ t={t} />
        <Contact t={t} contact={CONTACT} />
      </main>
      <Footer t={t} contact={CONTACT} logo={LOGO_URL} />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            color: "#FFFFFF",
            border: "2px solid #E11D2E",
            borderRadius: 0,
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </>
  );
}

function App() {
  return (
    <div className="App bg-white text-[#0A0A0A]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
